import type { RouteDefinition } from "../route-definition.ts";

export const productAccountRoutes = {
  getStarted: {
    path: "/get-started",
    scope: "static",
    bucket: "app",
    entry: "nav",
    disposition: "page",
  },
  signIn: {
    path: "/sign-in",
    scope: "static",
    bucket: "app",
    entry: "workflow",
    disposition: "page",
  },
  completeProfile: {
    path: "/complete-profile",
    scope: "static",
    bucket: "app",
    entry: "workflow",
    disposition: "page",
  },
  githubConnect: {
    path: "/github/connect",
    scope: "static",
    bucket: "app",
    entry: "workflow",
    disposition: "page",
  },
  cliAuth: {
    path: "/cli-auth",
    scope: "static",
    bucket: "app",
    entry: "workflow",
    disposition: "page",
  },
  cliAuthComplete: {
    path: "/cli-auth/complete",
    scope: "static",
    bucket: "app",
    entry: "workflow",
    disposition: "page",
  },
  account: {
    path: "/account",
    scope: "static",
    bucket: "app",
    entry: "nav",
    disposition: "page",
  },
  accountAdvanced: {
    path: "/account/advanced",
    scope: "static",
    bucket: "app",
    entry: "parent",
    disposition: "page",
  },
  accountCredentials: {
    path: "/account/credentials",
    scope: "static",
    bucket: "app",
    entry: "parent",
    disposition: "page",
  },
} as const satisfies Record<string, RouteDefinition>;
